import React from 'react';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
} from 'recharts';
import styled from 'styled-components';
import CustomTooltip from '../CustomTooltip';

const MainContainer = styled.div`
  width: 100%;
  height: 30vh;
`;

interface AreaChartComponentProps {
  // TODO: Replace `any` with specific type
  /* eslint-disable @typescript-eslint/no-explicit-any */
  data: any[];
  areaColor: string;
  xDataKey: string;
  yDataKey: string;
}

export const AreaChartComponent: React.FC<AreaChartComponentProps> = ({
  data,
  areaColor,
  xDataKey,
  yDataKey,
}) => {
  return (
    <MainContainer>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data}>
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="9.88%" stopColor={areaColor} stopOpacity={1} />
              <stop
                offset="90.12%"
                stopColor={`${areaColor}33`}
                stopOpacity={1}
              />
              <stop
                offset="100%"
                stopColor={`${areaColor}00`}
                stopOpacity={1}
              />
            </linearGradient>
          </defs>
          <XAxis dataKey={xDataKey} axisLine={false} hide={true} />
          <YAxis domain={['auto', 'auto']} axisLine={false} hide={true} />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey={yDataKey}
            stroke={areaColor}
            strokeWidth="2.5px"
            fill="url(#colorUv)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </MainContainer>
  );
};
